export const hdnTypes = [
    "01 Vrijstaande woning",
    "02 2-onder-1-kapwoning",
    "03 Geschakelde 2-onder-1-kapwoning",
    "04 Geschakelde woning",
    "05 Halfvrijstaande woning",
    "06 Tussenwoning",
    "07 Hoekwoning",
    "08 Eindwoning",
    "09 Galerijflat",
    "10 Portiekflat",
    "11 Corridorflat",
    "12 Maisonnette",
    "13 Benedenwoning",
    "14 Bovenwoning",
    "15 Portiekwoning",
    "16 Woonwagen / stacaravan",
    "17 Woonwagenstandplaats / stacaravanstandplaats",
    "18 Woonboot",
    "19 Ligplaats",
    "20 Waterwoning",
    "21 Woon-/winkelpand",
    "22 Bouwkavel",
    "23 Garage",
    "24 Parkeerplaats (dienstbaar aan wonen)",
    "25 Berging",
];
export function mapFundaType(type) {
    const pattern = /^((.*?)(, (.*?))?)( \((.*)\))?$/;
    const primaryType = type.match(pattern)?.[2]?.toLowerCase();
    const situationType = type.match(pattern)?.[4]?.toLowerCase();
    const extra = type.match(pattern)?.[6]?.toLowerCase();
    if (!primaryType) {
        return undefined;
    }
    switch (primaryType) {
        case "woonboot":
            return "18 Woonboot";
        case "ligplaats":
            return "19 Ligplaats";
        case "woonwagen":
            return "16 Woonwagen / stacaravan";
        case "berging":
        case "opslagruimte":
            return "25 Berging";
        case "parkeerplaats":
        case "parkeerkelder":
            return "24 Parkeerplaats (dienstbaar aan wonen)";
        case "garage":
        case "inpandige garage":
            return "23 Garage";
        case "bouwgrond":
            return "22 Bouwkavel";
        case "portiekflat":
            return "10 Portiekflat";
        case "portiekwoning":
            return "15 Portiekwoning";
        case "galerijflat":
            return "09 Galerijflat";
        case "maisonnette":
            return "12 Maisonnette";
        case "benedenwoning":
        case "dubbel benedenhuis":
            return "13 Benedenwoning";
        case "bovenwoning":
        case "tussenverdieping":
            return "14 Bovenwoning";
    }
    switch (situationType) {
        case "2-onder-1-kapwoning":
            return "02 2-onder-1-kapwoning";
        case "eindwoning":
            return "08 Eindwoning";
        case "geschakelde 2-onder-1-kapwoning":
            return "03 Geschakelde 2-onder-1-kapwoning";
        case "geschakelde woning":
        case "verspringend":
            return "04 Geschakelde woning";
        case "halfvrijstaande woning":
            return "05 Halfvrijstaande woning";
        case "hoekwoning":
            return "07 Hoekwoning";
        case "tussenwoning":
            return "06 Tussenwoning";
        case "vrijstaande woning":
            return "01 Vrijstaande woning";
    }
    switch (extra) {
        case "corridorflat":
            return "11 Corridorflat";
    }
    if (primaryType === "beneden + bovenwoning" && extra === "dubbel bovenhuis") {
        return "14 Bovenwoning";
    }
    if (extra?.includes("open portiek")) {
        return "15 Portiekwoning";
    }
    return undefined;
}
// const primaryTypes = [
// 	"Beneden + bovenwoning",
// 	"Benedenwoning",
// 	"Berging",
// 	"Bouwgrond",
// 	"Bovenwoning",
// 	"Bungalow",
// 	"Dubbel benedenhuis",
// 	"Eengezinswoning",
// 	"Galerijflat",
// 	"Garage",
// 	"Grachtenpand",
// 	"Herenhuis",
// 	"Inpandige garage",
// 	"Landgoed",
// 	"Landhuis",
// 	"Ligplaats",
// 	"Maisonnette",
// 	"Onderstuk",
// 	"Opslagruimte",
// 	"Parkeerkelder",
// 	"Parkeerplaats",
// 	"Penthouse",
// 	"Portiekflat",
// 	"Portiekwoning",
// 	"Stacaravan",
// 	"Studentenkamer",
// 	"Tussenverdieping",
// 	"Villa",
// 	"Woonboerderij",
// 	"Woonboot",
// 	"Woonwagen",
// ] as const;
//
// const situationTypes = [
// 	"2-onder-1-kapwoning",
// 	"eindwoning",
// 	"geschakelde 2-onder-1-kapwoning",
// 	"geschakelde woning",
// 	"halfvrijstaande woning",
// 	"hoekwoning",
// 	"tussenwoning",
// 	"verspringend",
// 	"vrijstaande woning",
// ] as const;
// export const fundaTypes = [
// 	"Beneden + bovenwoning",
// 	"Beneden + bovenwoning (appartement)",
// 	"Beneden + bovenwoning (bel-etage)",
// 	"Beneden + bovenwoning (corridorflat)",
// 	"Beneden + bovenwoning (dubbel bovenhuis)",
// 	"Benedenwoning",
// 	"Benedenwoning (appartement met open portiek)",
// 	"Benedenwoning (appartement)",
// 	"Benedenwoning (bel-etage)",
// 	"Benedenwoning (corridorflat)",
// 	"Benedenwoning (dubbel bovenhuis)",
// 	"Benedenwoning (open portiek)",
// 	"Benedenwoning (service flat)",
// 	"Benedenwoning (souterrain)",
// 	"Berging",
// 	"Bouwgrond",
// 	"Bovenwoning",
// 	"Bovenwoning (appartement met open portiek)",
// 	"Bovenwoning (appartement)",
// 	"Bovenwoning (bel-etage)",
// 	"Bovenwoning (corridorflat)",
// 	"Bovenwoning (dubbel bovenhuis met open portiek)",
// 	"Bovenwoning (dubbel bovenhuis)",
// 	"Bovenwoning (open portiek)",
// 	"Bovenwoning (service flat)",
// 	"Bungalow, 2-onder-1-kapwoning",
// 	"Bungalow, 2-onder-1-kapwoning (patiowoning)",
// 	"Bungalow, 2-onder-1-kapwoning (semi-bungalow)",
// 	"Bungalow, 2-onder-1-kapwoning (split-level woning)",
// 	"Bungalow, eindwoning",
// 	"Bungalow, eindwoning (patiowoning)",
// 	"Bungalow, eindwoning (semi-bungalow)",
// 	"Bungalow, geschakelde 2-onder-1-kapwoning",
// 	"Bungalow, geschakelde 2-onder-1-kapwoning (semi-bungalow)",
// 	"Bungalow, geschakelde woning",
// 	"Bungalow, geschakelde woning (bedrijfs- of dienstwoning)",
// 	"Bungalow, geschakelde woning (hofjeswoning)",
// 	"Bungalow, geschakelde woning (kwadrant woning)",
// 	"Bungalow, geschakelde woning (patiowoning)",
// 	"Bungalow, geschakelde woning (semi-bungalow)",
// 	"Bungalow, geschakelde woning (split-level woning)",
// 	"Bungalow, halfvrijstaande woning",
// 	"Bungalow, halfvrijstaande woning (bedrijfs- of dienstwoning)",
// 	"Bungalow, halfvrijstaande woning (patiowoning)",
// 	"Bungalow, halfvrijstaande woning (semi-bungalow)",
// 	"Bungalow, hoekwoning",
// 	"Bungalow, hoekwoning (patiowoning)",
// 	"Bungalow, hoekwoning (semi-bungalow)",
// 	"Bungalow, tussenwoning",
// 	"Bungalow, tussenwoning (hofjeswoning)",
// 	"Bungalow, tussenwoning (patiowoning)",
// 	"Bungalow, tussenwoning (semi-bungalow)",
// 	"Bungalow, verspringend",
// 	"Bungalow, verspringend (patiowoning)",
// 	"Bungalow, verspringend (semi-bungalow)",
// 	"Bungalow, vrijstaande woning",
// 	"Bungalow, vrijstaande woning (bedrijfs- of dienstwoning)",
// 	"Bungalow, vrijstaande woning (dijkwoning)",
// 	"Bungalow, vrijstaande woning (patiowoning)",
// 	"Bungalow, vrijstaande woning (semi-bungalow)",
// 	"Bungalow, vrijstaande woning (split-level woning)",
// 	"Dubbel benedenhuis",
// 	"Dubbel benedenhuis (appartement met open portiek)",
// 	"Dubbel benedenhuis (appartement)",
// 	"Dubbel benedenhuis (bel-etage)",
// 	"Dubbel benedenhuis (dubbel bovenhuis)",
// 	"Dubbel benedenhuis (souterrain)",
// 	"Eengezinswoning, 2-onder-1-kapwoning",
// 	"Eengezinswoning, 2-onder-1-kapwoning (bedrijfs- of dienstwoning)",
// 	"Eengezinswoning, 2-onder-1-kapwoning (dijkwoning)",
// 	"Eengezinswoning, 2-onder-1-kapwoning (drive-in woning)",
// 	"Eengezinswoning, 2-onder-1-kapwoning (hofjeswoning)",
// 	"Eengezinswoning, 2-onder-1-kapwoning (patiowoning)",
// 	"Eengezinswoning, 2-onder-1-kapwoning (split-level woning)",
// 	"Eengezinswoning, 2-onder-1-kapwoning (waterwoning)",
// 	"Eengezinswoning, eindwoning",
// 	"Eengezinswoning, eindwoning (dijkwoning)",
// 	"Eengezinswoning, eindwoning (drive-in woning)",
// 	"Eengezinswoning, eindwoning (hofjeswoning)",
// 	"Eengezinswoning, eindwoning (patiowoning)",
// 	"Eengezinswoning, eindwoning (split-level woning)",
// 	"Eengezinswoning, eindwoning (waterwoning)",
// 	"Eengezinswoning, eindwoning (wind- of watermolen)",
// 	"Eengezinswoning, geschakelde 2-onder-1-kapwoning",
// 	"Eengezinswoning, geschakelde 2-onder-1-kapwoning (dijkwoning)",
// 	"Eengezinswoning, geschakelde 2-onder-1-kapwoning (drive-in woning)",
// 	"Eengezinswoning, geschakelde 2-onder-1-kapwoning (hofjeswoning)",
// 	"Eengezinswoning, geschakelde 2-onder-1-kapwoning (kwadrant woning)",
// 	"Eengezinswoning, geschakelde 2-onder-1-kapwoning (patiowoning)",
// 	"Eengezinswoning, geschakelde 2-onder-1-kapwoning (split-level woning)",
// 	"Eengezinswoning, geschakelde 2-onder-1-kapwoning (wind- of watermolen)",
// 	"Eengezinswoning, geschakelde woning",
// 	"Eengezinswoning, geschakelde woning (bedrijfs- of dienstwoning)",
// 	"Eengezinswoning, geschakelde woning (dijkwoning)",
// 	"Eengezinswoning, geschakelde woning (drive-in woning)",
// 	"Eengezinswoning, geschakelde woning (hofjeswoning)",
// 	"Eengezinswoning, geschakelde woning (kwadrant woning)",
// 	"Eengezinswoning, geschakelde woning (patiowoning)",
// 	"Eengezinswoning, geschakelde woning (split-level woning)",
// 	"Eengezinswoning, geschakelde woning (waterwoning)",
// 	"Eengezinswoning, halfvrijstaande woning",
// 	"Eengezinswoning, halfvrijstaande woning (bedrijfs- of dienstwoning)",
// 	"Eengezinswoning, halfvrijstaande woning (dijkwoning)",
// 	"Eengezinswoning, halfvrijstaande woning (drive-in woning)",
// 	"Eengezinswoning, halfvrijstaande woning (hofjeswoning)",
// 	"Eengezinswoning, halfvrijstaande woning (kwadrant woning)",
// 	"Eengezinswoning, halfvrijstaande woning (patiowoning)",
// 	"Eengezinswoning, halfvrijstaande woning (split-level woning)",
// 	"Eengezinswoning, hoekwoning",
// 	"Eengezinswoning, hoekwoning (bedrijfs- of dienstwoning)",
// 	"Eengezinswoning, hoekwoning (dijkwoning)",
// 	"Eengezinswoning, hoekwoning (drive-in woning)",
// 	"Eengezinswoning, hoekwoning (hofjeswoning)",
// 	"Eengezinswoning, hoekwoning (kwadrant woning)",
// 	"Eengezinswoning, hoekwoning (patiowoning)",
// 	"Eengezinswoning, hoekwoning (split-level woning)",
// 	"Eengezinswoning, hoekwoning (waterwoning)",
// 	"Eengezinswoning, tussenwoning",
// 	"Eengezinswoning, tussenwoning (bedrijfs- of dienstwoning)",
// 	"Eengezinswoning, tussenwoning (dijkwoning)",
// 	"Eengezinswoning, tussenwoning (drive-in woning)",
// 	"Eengezinswoning, tussenwoning (hofjeswoning)",
// 	"Eengezinswoning, tussenwoning (kwadrant woning)",
// 	"Eengezinswoning, tussenwoning (patiowoning)",
// 	"Eengezinswoning, tussenwoning (split-level woning)",
// 	"Eengezinswoning, tussenwoning (waterwoning)",
// 	"Eengezinswoning, verspringend",
// 	"Eengezinswoning, verspringend (bedrijfs- of dienstwoning)",
// 	"Eengezinswoning, verspringend (drive-in woning)",
// 	"Eengezinswoning, verspringend (hofjeswoning)",
// 	"Eengezinswoning, verspringend (split-level woning)",
// 	"Eengezinswoning, verspringend (waterwoning)",
// 	"Eengezinswoning, vrijstaande woning",
// 	"Eengezinswoning, vrijstaande woning (bedrijfs- of dienstwoning)",
// 	"Eengezinswoning, vrijstaande woning (dijkwoning)",
// 	"Eengezinswoning, vrijstaande woning (drive-in woning)",
// 	"Eengezinswoning, vrijstaande woning (hofjeswoning)",
// 	"Eengezinswoning, vrijstaande woning (patiowoning)",
// 	"Eengezinswoning, vrijstaande woning (split-level woning)",
// 	"Eengezinswoning, vrijstaande woning (waterwoning)",
// 	"Eengezinswoning, vrijstaande woning (wind- of watermolen)",
// 	"Galerijflat",
// 	"Galerijflat (appartement met open portiek)",
// 	"Galerijflat (appartement)",
// 	"Galerijflat (bel-etage)",
// 	"Galerijflat (corridorflat met open portiek)",
// 	"Galerijflat (corridorflat)",
// 	"Galerijflat (dubbel bovenhuis)",
// 	"Galerijflat (open portiek)",
// 	"Galerijflat (service flat)",
// 	"Galerijflat (verzorgingsflat)",
// 	"Garage",
// 	"Grachtenpand, 2-onder-1-kapwoning",
// 	"Grachtenpand, eindwoning",
// 	"Grachtenpand, geschakelde woning",
// 	"Grachtenpand, halfvrijstaande woning",
// 	"Grachtenpand, hoekwoning",
// 	"Grachtenpand, tussenwoning",
// 	"Grachtenpand, tussenwoning (patiowoning)",
// 	"Grachtenpand, vrijstaande woning",
// 	"Grachtenpand, vrijstaande woning (dijkwoning)",
// 	"Herenhuis, 2-onder-1-kapwoning",
// 	"Herenhuis, 2-onder-1-kapwoning (dijkwoning)",
// 	"Herenhuis, 2-onder-1-kapwoning (patiowoning)",
// 	"Herenhuis, 2-onder-1-kapwoning (split-level woning)",
// 	"Herenhuis, eindwoning",
// 	"Herenhuis, eindwoning (bedrijfs- of dienstwoning)",
// 	"Herenhuis, eindwoning (drive-in woning)",
// 	"Herenhuis, eindwoning (split-level woning)",
// 	"Herenhuis, geschakelde 2-onder-1-kapwoning",
// 	"Herenhuis, geschakelde woning",
// 	"Herenhuis, geschakelde woning (bedrijfs- of dienstwoning)",
// 	"Herenhuis, geschakelde woning (dijkwoning)",
// 	"Herenhuis, geschakelde woning (split-level woning)",
// 	"Herenhuis, halfvrijstaande woning",
// 	"Herenhuis, halfvrijstaande woning (bedrijfs- of dienstwoning)",
// 	"Herenhuis, halfvrijstaande woning (drive-in woning)",
// 	"Herenhuis, halfvrijstaande woning (hofjeswoning)",
// 	"Herenhuis, halfvrijstaande woning (patiowoning)",
// 	"Herenhuis, halfvrijstaande woning (waterwoning)",
// 	"Herenhuis, hoekwoning",
// 	"Herenhuis, hoekwoning (dijkwoning)",
// 	"Herenhuis, hoekwoning (drive-in woning)",
// 	"Herenhuis, hoekwoning (kwadrant woning)",
// 	"Herenhuis, tussenwoning",
// 	"Herenhuis, tussenwoning (bedrijfs- of dienstwoning)",
// 	"Herenhuis, tussenwoning (dijkwoning)",
// 	"Herenhuis, tussenwoning (drive-in woning)",
// 	"Herenhuis, tussenwoning (hofjeswoning)",
// 	"Herenhuis, tussenwoning (kwadrant woning)",
// 	"Herenhuis, tussenwoning (patiowoning)",
// 	"Herenhuis, tussenwoning (split-level woning)",
// 	"Herenhuis, verspringend",
// 	"Herenhuis, verspringend (hofjeswoning)",
// 	"Herenhuis, vrijstaande woning",
// 	"Herenhuis, vrijstaande woning (bedrijfs- of dienstwoning)",
// 	"Herenhuis, vrijstaande woning (dijkwoning)",
// 	"Herenhuis, vrijstaande woning (drive-in woning)",
// 	"Herenhuis, vrijstaande woning (waterwoning)",
// 	"Inpandige garage",
// 	"Landgoed, vrijstaande woning",
// 	"Landgoed, vrijstaande woning (dijkwoning)",
// 	"Landhuis, 2-onder-1-kapwoning",
// 	"Landhuis, geschakelde woning",
// 	"Landhuis, halfvrijstaande woning",
// 	"Landhuis, hoekwoning",
// 	"Landhuis, vrijstaande woning",
// 	"Landhuis, vrijstaande woning (bedrijfs- of dienstwoning)",
// 	"Landhuis, vrijstaande woning (dijkwoning)",
// 	"Landhuis, vrijstaande woning (drive-in woning)",
// 	"Landhuis, vrijstaande woning (split-level woning)",
// 	"Landhuis, vrijstaande woning (waterwoning)",
// 	"Landhuis, vrijstaande woning (wind- of watermolen)",
// 	"Ligplaats",
// 	"Maisonnette",
// 	"Maisonnette (appartement met open portiek)",
// 	"Maisonnette (appartement)",
// 	"Maisonnette (bel-etage)",
// 	"Maisonnette (corridorflat)",
// 	"Maisonnette (dubbel bovenhuis met open portiek)",
// 	"Maisonnette (dubbel bovenhuis)",
// 	"Maisonnette (open portiek)",
// 	"Maisonnette (service flat met open portiek)",
// 	"Maisonnette (service flat)",
// 	"Maisonnette (souterrain)",
// 	"Onderstuk",
// 	"Opslagruimte",
// 	"Parkeerkelder",
// 	"Parkeerplaats",
// 	"Penthouse",
// 	"Penthouse (appartement met open portiek)",
// 	"Penthouse (appartement)",
// 	"Penthouse (corridorflat)",
// 	"Penthouse (dubbel bovenhuis)",
// 	"Penthouse (service flat)",
// 	"Portiekflat",
// 	"Portiekflat (appartement met open portiek)",
// 	"Portiekflat (appartement)",
// 	"Portiekflat (bel-etage)",
// 	"Portiekflat (corridorflat met open portiek)",
// 	"Portiekflat (corridorflat)",
// 	"Portiekflat (dubbel bovenhuis met open portiek)",
// 	"Portiekflat (dubbel bovenhuis)",
// 	"Portiekflat (open portiek)",
// 	"Portiekflat (service flat)",
// 	"Portiekflat (souterrain met open portiek)",
// 	"Portiekflat (souterrain)",
// 	"Portiekflat (verzorgingsflat)",
// 	"Portiekwoning",
// 	"Portiekwoning (appartement met open portiek)",
// 	"Portiekwoning (appartement)",
// 	"Portiekwoning (bel-etage)",
// 	"Portiekwoning (corridorflat)",
// 	"Portiekwoning (dubbel bovenhuis met open portiek)",
// 	"Portiekwoning (dubbel bovenhuis)",
// 	"Portiekwoning (open portiek)",
// 	"Portiekwoning (service flat)",
// 	"Stacaravan, vrijstaande woning",
// 	"Studentenkamer",
// 	"Studentenkamer (appartement)",
// 	"Studentenkamer (dubbel bovenhuis)",
// 	"Tussenverdieping",
// 	"Tussenverdieping (appartement met open portiek)",
// 	"Tussenverdieping (appartement)",
// 	"Tussenverdieping (bel-etage)",
// 	"Tussenverdieping (corridorflat)",
// 	"Tussenverdieping (dubbel bovenhuis)",
// 	"Tussenverdieping (open portiek)",
// 	"Tussenverdieping (service flat)",
// 	"Villa, 2-onder-1-kapwoning",
// 	"Villa, 2-onder-1-kapwoning (dijkwoning)",
// 	"Villa, eindwoning",
// 	"Villa, geschakelde 2-onder-1-kapwoning",
// 	"Villa, geschakelde woning",
// 	"Villa, geschakelde woning (dijkwoning)",
// 	"Villa, geschakelde woning (drive-in woning)",
// 	"Villa, geschakelde woning (waterwoning)",
// 	"Villa, halfvrijstaande woning",
// 	"Villa, halfvrijstaande woning (drive-in woning)",
// 	"Villa, halfvrijstaande woning (waterwoning)",
// 	"Villa, hoekwoning",
// 	"Villa, tussenwoning",
// 	"Villa, tussenwoning (patiowoning)",
// 	"Villa, tussenwoning (waterwoning)",
// 	"Villa, vrijstaande woning",
// 	"Villa, vrijstaande woning (bedrijfs- of dienstwoning)",
// 	"Villa, vrijstaande woning (dijkwoning)",
// 	"Villa, vrijstaande woning (drive-in woning)",
// 	"Villa, vrijstaande woning (hofjeswoning)",
// 	"Villa, vrijstaande woning (split-level woning)",
// 	"Villa, vrijstaande woning (waterwoning)",
// 	"Villa, vrijstaande woning (wind- of watermolen)",
// 	"Woonboerderij, 2-onder-1-kapwoning",
// 	"Woonboerderij, 2-onder-1-kapwoning (dijkwoning)",
// 	"Woonboerderij, geschakelde 2-onder-1-kapwoning",
// 	"Woonboerderij, geschakelde woning",
// 	"Woonboerderij, halfvrijstaande woning",
// 	"Woonboerderij, hoekwoning",
// 	"Woonboerderij, tussenwoning",
// 	"Woonboerderij, vrijstaande woning",
// 	"Woonboerderij, vrijstaande woning (bedrijfs- of dienstwoning)",
// 	"Woonboerderij, vrijstaande woning (dijkwoning)",
// 	"Woonboot, vrijstaande woning",
// 	"Woonboot, vrijstaande woning (waterwoning)",
// 	"Woonwagen, vrijstaande woning",
// ];
//
// for (const type of fundaTypes) {
// 	const hdnType = mapFundaType(type);
// 	if (!hdnType) {
// 		console.log(type, hdnType);
// 	}
// }
